<fa-icon *ngIf="faIcon" [icon]="[faPrefix, faIcon]" [ngStyle]="extendedIconStyle"> </fa-icon>
<img *ngIf="imgIcon" [src]="imgIcon" [ngStyle]="extendedIconStyle" [alt]="alt" />
<svg-icon *ngIf="svgIcon" [src]="svgIcon" [viewBox]="viewBox" [svgStyle]="extendedIconStyle"></svg-icon>
